import { render, staticRenderFns } from "./CreateMultiSelection.vue?vue&type=template&id=2706e3b0&scoped=true"
import script from "./CreateMultiSelection.vue?vue&type=script&lang=js"
export * from "./CreateMultiSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706e3b0",
  null
  
)

export default component.exports